import React from "react";
import { useRecoilValue } from "recoil";
import Props from "./index.d";

const ConditionalFormModeFieldSet: React.FC<Props> = (props) => {
  const { className, renderOnCondition = "unit", children, formAtom } = props;

  const formValues = useRecoilValue(formAtom);

  // Default to "unit" if __unitFormMode is undefined
  const currentMode = formValues?.__unitFormMode || "unit";
  const shouldRender = currentMode === renderOnCondition;

  // Use CSS display instead of unmounting to preserve form field states
  // This prevents the hasActivePowerRange switch from losing its state during tab switches
  return (
    <div
      className={className}
      style={{
        display: shouldRender ? "block" : "none",
      }}
    >
      {children}
    </div>
  );
};

export default ConditionalFormModeFieldSet;
